/**
 * Base Filter class - defines the interface for custom Filters
 */
export class Filter {
  check() {
    throw new Error('Not Implemented');
  }
}
